class QuickbuyContainer {
    constructor() {
        this.container = document.querySelector('[data-quickbuy-container]')
        this.productContainer = this.container.querySelector('[data-popup-product]')
        this.attachListeners()
    }

    openQuickbuy() {
        this.container.setAttribute('aria-hidden', false)
    }

    closeQuickbuy() {
        this.container.setAttribute('aria-hidden', true)
    }

    attachListeners() {
        this.container.querySelector('.overlay').addEventListener('click', () => {
            this.closeQuickbuy()
        })

        this.container.querySelector('.product-popup-close').addEventListener('click', () => {
            this.closeQuickbuy()
        })
    }    

    getProduct(handle) {
        fetch(`/products/${handle}.js`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json'
            }
        }).then((res) => {
            return res.json()
        }).then((product) => {
            this.buildProduct(product)
        })
    }

    getImageWidths(image) {
        let sizes = []

        for (let index = 0; index < image.width; index+=50) {
            sizes.push(index)
        }

        return sizes
    }

    buildProduct(product) {

        const getProductLabels = () => {
            const labels = product.tags.filter(x => x.includes('__label'))
            if (labels.length == 0 && product.compare_at_price == product.price && product.available == true) return ''

            let output = '<div class="Product__LabelList no--padding" style="padding-bottom: 0.5rem;">'
            
            if (product.available) {
                if (product.compare_at_price > product.price) {
                    const percentOff = Math.floor(((product.compare_at_price - product.price) * 100) / product.compare_at_price)
                    output += `<span data-bind="discount" class="ProductItem__Label ProductItem__Label--onSale Heading Text--subdued">${window.languages.discountText} ${percentOff}%</span>`
                }
            } else {
                output += `<span data-bind="sold_out" class="ProductItem__Label ProductItem__Label--soldOut Heading Text--subdued">${window.languages.soldoutLabel}</span>`
            }


            labels.forEach((label) => {
                const labelText = label.split('__label:')[1]
                output += `<span data-bind="${labelText}" class="ProductItem__Label Heading Text--subdued">${labelText}</span>`
            })

            output += '</div>'

            return output
        }

        const getProductBuyButton = () => {
            let output = `
            <div class="ProductForm__BuyButtons">
                <button class="ProductForm__AddToCart Button Button--primary Button--full">
            `

            if(product.available) {
                output += `
                    <span class="js-add-to-cart-text">${window.languages.productFormAddToCart}</span>
                    <span class="Button__SeparatorDot"></span>
                    <span>${Shopify.formatMoney(product.price, window.theme.moneyFormat)}</span>
                `
            } else {
                output += window.languages.productFormSoldOut
            }
            output += '</button></div>'

            return output
        }

        const getProductVariants = () => {
            let selectedVariant = false
            let output = `<div class="ProductForm__Variants">`
            for (let i = 0; i < product.options.length; i++) {
                const option = product.options[i];

                output += `
                <div class="ProductForm__Option ProductForm__Option--labelled">
                    <span class="ProductForm__Label">${option.name}:</span>
                    <ul class="SizeSwatchList HorizontalList HorizontalList--spacingTight">
                `

                for (let j = 0; j < option.values.length; j++) {
                    const value = option.values[j];

                    output += `
                    <li class="HorizontalList__Item">
                        <input id="${product.variants[j].id}" type="radio" class="SizeSwatch__Radio" value="${value}" name="option-${i}"
                    `

                    if(!selectedVariant && product.variants[j].available) {
                        selectedVariant = true
                        output += `checked="checked">`
                    } else if (!product.variants[j].available) {
                        output += `disabled>`
                    } else {
                        output += `>`
                    }
                    
                    output += `
                        <label for="${product.variants[j].id}" class="SizeSwatch${product.variants[j].available ? `` : ` label__disabled`}">${value}</label>
                    </li>`
                }

                output += `</ul></div></div>`
            }
            return output
        }


        this.productContainer.innerHTML = ''
        const html = `
            <div class="product-image-wrapper">
                <div class="product-popup-image">
                    <img class="Image--lazyLoad Image--fadeIn" data-src="${product.media[0].src}" data-widths="${this.getImageWidths(product.media[0])}" data-sizes="auto" alt="${product.media[0].alt}">
                </div>
            </div>

            <div class="product-popup-content">
            
            <div class="product__popup--meta">
                <h2 class="Heading">${product.title}</h2>

                ${getProductLabels()}

                <div class="product__popup--meta--description">${product.description}</div>

                <div class="product-form">
                    ${getProductVariants()}

                    <div class="ProductForm__QuantitySelector">
                        <div class="PopupQuantity QuantitySelector QuantitySelector--large">
                            <button type="button" class="QuantitySelector__Button Link Link--secondary" data-action="decrease-quantity">
                                <svg class="Icon Icon--minus" role="presentation" viewBox="0 0 16 2">
                                    <path d="M1,1 L15,1" stroke="currentColor" fill="none" fill-rule="evenodd" stroke-linecap="square"></path>
                                </svg>
                            </button>
                            <input type="text" class="QuantitySelector__CurrentQuantity" pattern="[0-9]*" name="quantity" value="1" aria-label="quantity selector">
                            <button type="button" class="QuantitySelector__Button Link Link--secondary" data-action="increase-quantity">
                                <svg class="Icon Icon--plus" role="presentation" viewBox="0 0 16 16">
                                    <g stroke="currentColor" fill="none" fill-rule="evenodd" stroke-linecap="square">
                                    <path d="M8,1 L8,15"></path>
                                    <path d="M1,8 L15,8"></path>
                                    </g>
                                </svg>
                            </button>
                        </div>
                    </div>

                    <div class="wishlist--wrapper">
                        <!-- include 'wishlist-button-product' with '${product.id}' -->
                    </div>

                    ${getProductBuyButton()}


                </div>
            </div>


          </div>
        `
        this.productContainer.innerHTML = html
        this.attachFormListeners()
        this.openQuickbuy()
    }

    attachFormListeners() {
        const quantityInput = this.productContainer.querySelector('.QuantitySelector__CurrentQuantity')
        const increaseQuantity = this.productContainer.querySelector('[data-action="increase-quantity"]')
        const decreaseQuantity = this.productContainer.querySelector('[data-action="decrease-quantity"]')

        increaseQuantity.addEventListener('click', () => {
            quantityInput.value = parseInt(quantityInput.value) + 1
        })

        decreaseQuantity.addEventListener('click', () => {
            if(quantityInput.value == 1) return
            quantityInput.value = parseInt(quantityInput.value) - 1
        })

        const submitBtn = this.productContainer.querySelector('.ProductForm__AddToCart')

        submitBtn.addEventListener('click', () => {
            this.submitProduct()
        })
    }

    submitProduct() {
        const _this = this
        const variant = parseInt(this.productContainer.querySelector('.ProductForm__Variants input:checked').getAttribute('id'))
        const quantity = parseInt(this.productContainer.querySelector('.QuantitySelector__CurrentQuantity').value)

        const productItem = {
            id: variant,
            quantity: quantity ? quantity : 1
        }

        fetch('/cart/add.js', {
        body: JSON.stringify(productItem),
        credentials: 'same-origin',
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest'
        }
        }).then(function (response) {
            if (response.ok) {
                _this.closeQuickbuy()
                document.body.dispatchEvent(new CustomEvent('product:added', {
                bubbles: true,
                detail: {
                    variant: variant,
                    quantity: quantity ? quantity : 1,
                }
                }));
            } else {
                alert('Not enough inventory left')
            }
        });
    }
}


class QuickbuyTrigger {
    constructor(node, quickbuyContainer) {
        this.container = quickbuyContainer
        this.node = node
        this.attachListener()
    }

    triggerQuickBuy() {
        this.container.getProduct(this.node.dataset.triggerPopup)
    }

    attachListener() {
        this.node.addEventListener('click', () => {
            if(window.innerWidth <= 750) return
            this.triggerQuickBuy()
        })
    }
}


let storedTriggers = [];
const container = new QuickbuyContainer()


const getQuickbuyTriggers = () => {
    const quickBuyTriggers = document.querySelectorAll('[data-trigger-popup]');

    quickBuyTriggers.forEach((trigger) => {
        if(storedTriggers.includes(trigger)) return

            storedTriggers.push(trigger)
            new QuickbuyTrigger(trigger, container)
    })
}

document.addEventListener('DOMContentLoaded', () => {    
    getQuickbuyTriggers();
})

document.addEventListener('collection:reload', () => { 
    getQuickbuyTriggers();
})

document.addEventListener('dynamic:section:loaded', () => {
    getQuickbuyTriggers();
})